import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import TabNav from './TabNav';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: '1rem'
  }
}));

const Information = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <TabNav />
    </div>
  );
};

export default withRouter(Information);
